import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  get_vendors,
  get_vendor_emails,
  orders,
  get_orders,
  view_AdminOrderDetails,
  add_excel_data,
  get_materials,
  approve_order_by_vendor,
  reject_order_by_vendor,
  get_InvoiceListByOrderId,
  get_invoiceListForDropdown,
  create_ledgerForOfficer,
  get_ledgerList,
  get_viewLedgerDetails,
} from "./adminOrdersAPI";

const initialState = {
  loading: false,
  vendors: [],
  materials: [],
  vendoremails: [],
  ordersList: [],
  invoiceListLoading: false,
  adminOrderDetails: [],
  approveOrderLoading: false,
  invoiceList: {},
  invoiceDropdown: [],
  invoiceDropdownLoading: false,
  createLedgerLoading: false,
  ledgerList: {},
  ledgerListLoading: false,
  ledgerDetails: {},
  ledgerDetailsLoaing: false,
};
const actions = {
  GETVENDORS: "getVendors/GETVENDORS",
  GETVENDOREMAILS: "getVendorsemails/GETVENDOREMAILS",
  GETMATERIALS: "getMaterials/GETMATERIALS",
  CREATEORDER: "createOrder/CREATEORDER",
  GETORDERS: "getOrders/GETORDERS",
  ADDEXCEL: "addExcel/ADDEXCEL",
  VIEWADMINORDERDETAILS: "getAdminOrderDetails/VIEWADMINORDERDETAILS",
  APPROVEORDERBYVENDOR: "approveOrderByVendor/APPROVEORDERBYVENDOR",
  REJECTORDERBYVENDOR: "rejectOrderByVendor/REJECTORDERBYVENDOR",
  GETINVOICELISTBYORDERID: "getInvoiceListByOrderId/GETINVOICELISTBYORDERID",
  GETINVOICELISTFORDROPDOWN:
    "getInvoiceListForDropdown/GETINVOICELISTFORDROPDOWN",
  CREATELEDGER: "createLedger/CREATELEDGER",
  GETLEDGERLIST: "getLedgerList/GETLEDGERLIST",
  GETVIEWLEDGERDETAILS: "getViewLedgerDetails/GETVIEWLEDGERDETAILS",
};

export const addExcelData = createAsyncThunk(
  actions.ADDEXCEL,
  async (payload) => {
    const response = await add_excel_data(payload);
    return response;
  }
);
export const getVendors = createAsyncThunk(
  actions.GETVENDORS,
  async (payload) => {
    const response = await get_vendors(payload);
    return response;
  }
);

export const getMaterials = createAsyncThunk(
  actions.GETMATERIALS,
  async (payload) => {
    const response = await get_materials(payload);
    return response;
  }
);

export const getVendorsemails = createAsyncThunk(
  actions.GETVENDOREMAILS,
  async (payload) => {
    const response = await get_vendor_emails(payload);
    return response;
  }
);

export const createOrder = createAsyncThunk(
  actions.CREATEORDER,
  async (payload) => {
    const response = await orders(payload);
    return response;
  }
);

export const getAdminOrderDetails = createAsyncThunk(
  actions.VIEWADMINORDERDETAILS,
  async (payload) => {
    const response = await view_AdminOrderDetails(payload);
    return response;
  }
);

export const getOrders = createAsyncThunk(
  actions.GETORDERS,
  async (payload) => {
    const response = await get_orders(payload);
    return response;
  }
);
export const approveOrderByVendor = createAsyncThunk(
  actions.APPROVEORDERBYVENDOR,
  async (payload) => {
    const response = await approve_order_by_vendor(payload);
    return response;
  }
);
export const rejectOrderByVendor = createAsyncThunk(
  actions.REJECTORDERBYVENDOR,
  async (payload) => {
    const response = await reject_order_by_vendor(payload);
    return response;
  }
);
export const getInvoiceListByOrderId = createAsyncThunk(
  actions.GETINVOICELISTBYORDERID,
  async (payload) => {
    const response = await get_InvoiceListByOrderId(payload);
    return response;
  }
);
export const getInvoiceListForDropdown = createAsyncThunk(
  actions.GETINVOICELISTFORDROPDOWN,
  async (payload) => {
    const response = await get_invoiceListForDropdown(payload);
    return response;
  }
);
export const createLedger = createAsyncThunk(
  actions.CREATELEDGER,
  async (payload) => {
    const response = await create_ledgerForOfficer(payload);
    return response;
  }
);
export const getLedgerList = createAsyncThunk(
  actions.GETLEDGERLIST,
  async (payload) => {
    const response = await get_ledgerList(payload);
    return response;
  }
);
export const getViewLedgerDetails = createAsyncThunk(
  actions.GETVIEWLEDGERDETAILS,
  async (payload) => {
    const response = await get_viewLedgerDetails(payload);
    return response;
  }
);
export const adminOrdersSlice = createSlice({
  name: "adminOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendors.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.vendors = data;
        if (success) {
          /*   message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getVendors.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getMaterials.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMaterials.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.materials = data;
        if (success) {
          /*   message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getMaterials.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getVendorsemails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorsemails.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.vendoremails = data;
        if (success) {
          /*  message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getVendorsemails.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(getAdminOrderDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminOrderDetails.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.adminOrderDetails = data;
        if (success) {
          /*  message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminOrderDetails.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createOrder.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(addExcelData.pending, (state) => {
        state.loading = true;
      })
      .addCase(addExcelData.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(addExcelData.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.ordersList = data;
        if (success) {
          /* message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getOrders.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(approveOrderByVendor.pending, (state) => {
        state.approveOrderLoading = true;
      })
      .addCase(approveOrderByVendor.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.approveOrderLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(approveOrderByVendor.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.approveOrderLoading = false;

        message.error(msg);
      });

    builder
      .addCase(rejectOrderByVendor.pending, (state) => {
        state.approveOrderLoading = true;
      })
      .addCase(rejectOrderByVendor.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.approveOrderLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(rejectOrderByVendor.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.approveOrderLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getInvoiceListByOrderId.pending, (state) => {
        state.invoiceListLoading = true;
      })
      .addCase(getInvoiceListByOrderId.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.invoiceListLoading = false;
        state.invoiceList = data;
        if (success) {
          // message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(getInvoiceListByOrderId.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.invoiceListLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getInvoiceListForDropdown.pending, (state) => {
        state.invoiceDropdownLoading = true;
      })
      .addCase(getInvoiceListForDropdown.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.invoiceDropdownLoading = false;
        state.invoiceDropdown = data;
        if (success) {
          // message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(getInvoiceListForDropdown.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.invoiceDropdownLoading = false;

        message.error(msg);
      });
    builder
      .addCase(createLedger.pending, (state) => {
        state.createLedgerLoading = true;
      })
      .addCase(createLedger.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.createLedgerLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createLedger.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.createLedgerLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getLedgerList.pending, (state) => {
        state.ledgerListLoading = true;
      })
      .addCase(getLedgerList.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.ledgerListLoading = false;
        state.ledgerList = data;
        if (success) {
          // message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(getLedgerList.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.ledgerListLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getViewLedgerDetails.pending, (state) => {
        state.ledgerDetailsLoaing = true;
      })
      .addCase(getViewLedgerDetails.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.ledgerDetailsLoaing = false;
        state.ledgerDetails = data;
        if (success) {
          // message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(getViewLedgerDetails.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.ledgerDetailsLoaing = false;

        message.error(msg);
      });
  },
});
export const adminOrdersActions = adminOrdersSlice.actions;
export const { resetadminOrdersDetails } = adminOrdersSlice.actions;

export default adminOrdersSlice.reducer;
